import styled, { css } from 'styled-components';

import { size } from '../layout/helpers';

export const Page = styled.div``;

type PageSectionProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  accent?: boolean;
  medium?: boolean;
  large?: boolean;
  fillSpace?: boolean;
};

export const PageSection = styled.section<PageSectionProps>`
  margin-bottom: ${size(4)};

  ${({ accent }: { accent?: boolean }) =>
    accent &&
    css`
      padding: ${size(4)} 0;
      background-color: var(--bg-accent, ${(props) => props.theme.color.accent});
      margin-bottom: 0;
    `}

  ${({ medium }: { medium?: boolean }) =>
    medium &&
    css`
      margin-bottom: ${size(5.5)};
    `}

  ${({ large }: { large?: boolean }) =>
    large &&
    css`
      margin-bottom: ${size(8)};
    `}

  ${({ accent, large }) =>
    accent &&
    large &&
    css`
      padding: ${size(8)} 0;
      margin-bottom: 0;
    `}

  ${({ fillSpace }: { fillSpace?: boolean }) =>
    fillSpace &&
    css`
      flex: 1 1 auto;
    `}
`;
